export class Assert
{
    public static fail(message:string = null):void
    {
        Assert.yes(false, message);
    }

    public static no(state:any, message:string = null):void
    {
        Assert.yes(!state, message);
    }

    public static yes(state:any, message:string = null):void
    {
        if( !state )
        {
            console.error(`Assertion error: ${message || '!'}`);
            throw new Error(message || 'Invalid state!');
        }
    }
}
